<template>
  <f7-page>
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true })"
        >
          {{ $t('LeftPanel_title_result') }} ({{ resultProject.name }})
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('LeftPanel_subtitle_irrigation') }}</span>
      </template>
    </navbar>
    <div class="transparent headers-initial">
      <f7-block-title class="block-title-result">
        <span class="color-title-OpenAir">ETc diaria - RIEGO</span>
      </f7-block-title>
    </div>
    <div class="content-devx transparent content-charts">
      <div class="chart">
        <DxChart
          id="chart"
          ref="chart1"
          :data-source="data"
          palette="Material"
          @legend-click="onLegendClick"
          @file-saving="onFileSaving"
        >
          <DxCommonSeriesSettings
            type="line"
            argument-field="ddp"
          />
          <DxSeries
            value-field="daily_crop_etc"
            name="ETc DIARIA (mm / d)"
            color="#5b9bd5"
          />
          <DxLegend
            vertical-alignment="bottom"
            horizontal-alignment="center"
            item-text-position="right"
            :visible="false"
          />
          <DxArgumentAxis
            title="Tiempo (días después de trasplante)"
          />
          <DxValueAxis
            :show-zero="true"
            position="left"
          >
            <DxTitle text="ETc (mm / d)" />
          </DxValueAxis>
          <DxTitle :text="'Evapotranspiración Diaria'" />
          <DxTooltip
            :enabled="true"
            :z-index="999999"
            :customize-tooltip="customizeTooltip"
          />

          <DxExport
            :enabled="true"
            :file-name="`${resultProject.name} - Riego - Evapotranspiración Diaria`"
          />
          <DxScrollBar :visible="true" />
          <DxZoomAndPan argument-axis="both" />
        </DxChart>
      </div>
      <div
        class="chart"
        style="padding-bottom: 1rem;"
      >
        <DxChart
          id="chart"
          ref="chart2"
          :data-source="data"
          palette="Material"
          @legend-click="onLegendClick"
          @file-saving="onFileSaving"
        >
          <DxCommonSeriesSettings
            type="bar"
            argument-field="ddp"
          />
          <DxSeries
            value-field="irrigation"
            name="Riego"
            color="#5b9bd5"
          />
          <DxSeries
            value-field="rainfall"
            name="Lluvia"
            color="#ed7d31"
          />
          <DxLegend
            vertical-alignment="bottom"
            horizontal-alignment="center"
            item-text-position="right"
            :visible="true"
          />
          <DxValueAxis
            :show-zero="true"
            position="left"
          >
            <DxTitle text="Riego o Lluvia (mm / d) " />
          </DxValueAxis>
          <DxArgumentAxis
            title="Tiempo (días después de trasplante)"
          />
          <DxTitle :text="'Riego - Lluvia'" />
          <DxTooltip
            :enabled="true"
            :z-index="999999"
            :customize-tooltip="customizeTooltip"
          />
          <DxExport
            :enabled="true"
            :file-name="`${resultProject.name} - Riego - Riego - Lluvia`"
          />
          <DxScrollBar :visible="true" />
          <DxZoomAndPan argument-axis="both" />
        </DxChart>
      </div>
    </div>
    <div
      v-if="DEVICE_PLATFORM !== 'android'"
      class="controls-pane"
      style="padding-bottom: 1rem;"
    >
      <DxButton
        id="export"
        style="background-color: #616B7C; padding: 0.5rem;"
        icon="export"
        type="default"
        :text="$t('exportGraphs')"
        @click="onClickExport()"
      />
    </div>
    <div class="transparent headers-initial">
      <div
        :class="`${showScroll ? 'scrollview-oa' : ''}`"
        style="display: flex; justify-content: center !important; align-items: center; width: auto"
      >
        <DxScrollView
          :scroll-by-content="showScroll"
          :scroll-by-thumb="showScroll"
          direction="both"
        >
          <DxDataGrid
            :data-source="data"
            :allow-column-reordering="true"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="false"
            :column-auto-width="true"
            :row-alternation-enabled="false"
            :word-wrap-enabled="true"
            no-data-text="Sin datos"
            @file-saving="onFileSaving"
          >
            <DxSelection
              mode="single"
            />
            <DxExport
              :enabled="true"
              :texts="{exportAll: 'Exportar',}"
              :file-name="`${resultProject.name} - RESULTADOS - Cultivo`"
            />
            <DxPaging
              :enabled="false"
              :page-size="10"
            />
            <DxPager
              :visible="false"
              :show-page-size-selector="true"
              :show-info="true"
              info-text="Página {0} de {1} ({2} días)"
              :allowed-page-sizes="['5', '10', '20', '30', '60']"
            />
            <DxHeaderFilter :visible="true" />
            <DxSearchPanel
              text=""
              :visible="true"
              :width="200"
              :placeholder="$t('Search_placeholder')"
            />
            <DxColumnFixing :enabled="true" />

            <DxColumn
              data-field="ddp"
              caption="Día después de trasplante"
              :allow-header-filtering="false"
              alignment="left"
              css-class="column-center break-word-column"
              :fixed="DEVICE_PLATFORM === 'android'"
            />
            <DxColumn
              data-field="daily_crop_etc"
              caption="ETc (mm / d)"
              :allow-header-filtering="false"
              alignment="left"
              format="#0.#"
            />
            <DxColumn
              data-field="irrigation"
              caption="Riego (mm / d)"
              :allow-header-filtering="false"
              alignment="left"
              format="#0.#"
            />
            <DxColumn
              data-field="rainfall"
              caption="Lluvia (mm / d)"
              :allow-header-filtering="false"
              alignment="left"
              format="#0.#"
            />
          </DxDataGrid>
        </DxScrollView>
      </div>
      <div
        class="controls-pane"
        style="margin-top: 1rem;"
      >
        <DxButton
          id="showAll"
          style="background-color: #616B7C; padding: 0.5rem;"
          type="default"
          :text="$t('showAll')"
          @click="showAll()"
        />
      </div>
    </div>
    <f7-block-footer
      class="content-action-botton"
    >
      <f7-link
        popover-open=".popover-menu"
        data-popover=".links-popover"
        class="dx-btn-success open-air dx-btn-see-more sm-popover"
      >
        {{ $t('seeMore') }}
      </f7-link>
      <f7-popover class="popover-menu links-popover">
        <f7-list>
          <f7-list-item
            link="/climateResult/"
            popover-close
            :title="$t('LeftPanel_subtitle_climate')"
          />
          <f7-list-item
            link="/cropResult/"
            popover-close
            :title="$t('LeftPanel_subtitle_crop')"
          />
          <f7-list-item
            link="/floorResult/WATER-CONTENT-DRAINAGE-LEACHING/"
            popover-close
            :title="$t('LeftPanel_subtitle_floor')"
          />
          <f7-list-item
            link="/contributionNResult/"
            popover-close
            :title="$t('LeftPanel_subtitle_contribution_N')"
          />
        </f7-list>
      </f7-popover>
      <f7-button
        class="dx-btn-cancel color-OpenAir"
        raised
        type="default"
        styling-mode="outlined"
        name="ButtonCancel"
        @click="goToResultOpenAirPage"
      >
        {{ $t("button_back") }}
      </f7-button>
    </f7-block-footer>
  </f7-page>
</template>
<script>
import { mapState } from 'vuex';
import {
  DxArgumentAxis,
  DxChart,
  DxCommonSeriesSettings, DxExport,
  DxLegend, DxScrollBar,
  DxSeries,
  DxTitle,
  DxTooltip, DxValueAxis, DxZoomAndPan,
} from 'devextreme-vue/chart';
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxColumnFixing,
  DxHeaderFilter,
  DxPager,
  DxSelection,
} from 'devextreme-vue/data-grid';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DxButton from 'devextreme-vue/button';
import { exportWidgets } from 'devextreme/viz/export';
import navbar from '../../../components/navbar/NavBar.vue';
import { DEVICE_PLATFORM, NUMBER_OF_DECIMALS } from '../../../js/constants';

export default {
  name: 'IrrigationResultPage',
  components: {
    navbar,
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxLegend,
    DxTitle,
    DxTooltip,
    DxScrollBar,
    DxZoomAndPan,
    DxExport,
    DxValueAxis,
    DxButton,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxColumnFixing,
    DxHeaderFilter,
    DxPager,
    DxSelection,
    DxScrollView,
  },
  data() {
    return {
      temperature: [],
      humidity: [],
      solarRadiation: [],
      eto: [],
      loaded: false,
      data: [],
      NUMBER_OF_DECIMALS,
      showScroll: true,
      DEVICE_PLATFORM,
    };
  },
  computed: {
    ...mapState('Result', [
      'resultProject',
    ]),
  },
  beforeMount() {
    this.$f7.preloader.show();
    try {
      this.keyName = this.$f7.views.main.router.currentRoute.path;
      this.data = this.resultProject.result.irrigation.map((irrigation, index) => ({
        ddp: index,
        irrigation,
        rainfall: this.resultProject.result.rainfall[index],
        daily_crop_etc: this.resultProject.result.daily_crop_etc[index],
      }));
      this.loaded = true;
    } catch (e) {
      console.log(e);
    } finally {
      this.$f7.preloader.hide();
    }

    this.$f7.preloader.hide();
  },
  methods: {
    showAll() {
      this.showScroll = !this.showScroll;
    },
    goToResultOpenAirPage() {
      this.$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true });
    },
    onLegendClick({ target: series }) {
      if (series.isVisible()) {
        series.hide();
      } else {
        series.show();
      }
    },
    customizeTooltip(pointInfo) {
      return {
        html: `<div><div class='tooltip-header'></div><div class='tooltip-body'>
          <span class='bold'> Tiempo (ddp): </span>${pointInfo.argument} </span> </div>
          <span class="bold"> ${pointInfo.seriesName}: </span> ${Number(pointInfo.valueText).toFixed(this.NUMBER_OF_DECIMALS)}
        </span> </div></div></div>`,
      };
    },
    onClickExport() {
      const chart1 = this.$refs.chart1.instance;
      const chart2 = this.$refs.chart2.instance;

      if (DEVICE_PLATFORM === 'android') {
        this.$refs.chart1.instance.exportTo(`${this.resultProject.name} - Riego - Evapotranspiración Diaria`, 'png');
        this.$refs.chart2.instance.exportTo(`${this.resultProject.name} - Riego - Riego - Lluvia`, 'png');
      } else {
        exportWidgets([[chart1, chart2]], {
          fileName: `${this.resultProject.name} - RESULTADOS RIEGO`,
          format: 'PNG',
        });
      }
    },
    onFileSaving(e) {
      if (DEVICE_PLATFORM === 'android') {
        cordova.plugins.saveDialog.saveFile(e.data, `${e.fileName}.${e.format}`).then((uri) => {
          console.info('The file has been successfully saved to', uri);
        }).catch((reason) => {
          console.warn(reason);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../css/mixins";
.block-title-result {
  border-bottom: 1px solid #51A411;
}

.content-charts {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  .chart {
    padding-bottom: 4rem;
    padding-left: 1rem;
    padding-right: 1rem;
    flex-basis: 100%;
    @include md {
      flex-basis: 45%;
    }
  }
}
</style>
